export default __webpack_public_path__ + "static/international-metric-desktop-17a46c7901ab8caa772c6bae3ac43913.svg";